import { atom, getDefaultStore } from 'jotai';

export type AkState = {
  accessKey: string;
  accessKeyExpired: boolean;
};

const akAtomInitValue: AkState = {
  accessKey: '',
  accessKeyExpired: false,
};

export const akAtom = atom<AkState>(akAtomInitValue);

const store = getDefaultStore();

export function getAkStore() {
  return store.get(akAtom);
}

export function setAkStore(akState: Partial<AkState>) {
  store.set(akAtom, (prev) => ({ ...prev, ...akState }));
}

export type TmapInfoState = {
  ak: string;
  appVersion: string;
  carrierName: string;
  deviceid: string;
  euk: string;
  osType: string;
  osVersion: string;
  sessionid?: string;
};

const tmapInfoAtomInitValue: TmapInfoState = {
  ak: '',
  appVersion: '',
  carrierName: '',
  deviceid: '',
  euk: '',
  osType: '',
  osVersion: '',
  sessionid: '',
};

export const tmapInfoAtom = atom<TmapInfoState>(tmapInfoAtomInitValue);
